import { useState, useEffect } from "react";
import Hero from "./Hero/Hero";
import Container from "Components/Container/Container";
import Gallery from "./Gallery/Gallery";
import Landing from "./Landing/Landing";
import { Link } from "react-router-dom";

// fetching data
import useFetch from "Hooks/useFetch";
import LoadingScreen from "Components/RequestHandler/LoadingScreen";
import IsError from "Components/RequestHandler/IsError";
import { useParams } from "react-router-dom";
const NewsDetails = () => {
  const { slug } = useParams();

  const [data, setData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const { fetchData, error } = useFetch();

  const getData = async () => {
    setIsLoading(true);
    setIsError(false);

    try {
      const data = await fetchData(`news/${slug}`);
      setData(data);
    } catch (error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, [slug]);

  if (isLoading) return <LoadingScreen />;
  if (error || isError) return <IsError />;
  if (data) {
    return (
      <main className="pb-secondary pb-primary">
        <Hero cat={data?.category} name={data?.title} />
        <Container>
          <div className="grid grid-cols-1  xl:grid-cols-3 gap-x-16 mt-14">
            <div className=" col-span-2">
              <Gallery data={data} />
              <Landing date={data?.date} data={data?.description} />
            </div>

            <div className="col-span-1 h-auto sticky top-0">
              <div className="sticky top-[10vh]">
                <p className="text-font uppercase text-4xl mb-6">Other news</p>
                <div className="bg-[#222] flex flex-col gap-y-6 text-white px-6 py-8 ">
                  {data?.news.map(({ date, title, slug }, index) => (
                    <Link className="group" to={`/news/${slug}`} key={index}>
                      <p>{date}</p>
                      <p className="text-2xl group-hover:underline capitalize">
                        {title}
                      </p>
                    </Link>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </Container>
      </main>
    );
  }
};

export default NewsDetails;
